module.exports = __webpack_public_path__ + "static/media/sort-amount-up-alt.7676b0b0.svg";